import React, { Component } from 'react'
import { Spin, Button, Form, Layout, Icon, PageHeader, Input, Select, Cascader, Upload, message, Table, InputNumber, Switch, Modal } from 'antd'
import Editor from 'wangeditor'
import PrevImg from '_src/components/PrevImg/PrevImg'
import { UploadIMGToOss,UploadMultipleIMGToOss } from '_src/utils/base'
import { getGoodDetail, goodsCategoryList, goodsTopic, editGoods, goodsSpeciDelete } from '_src/api/api'
import './style/index.less'

const { Option } = Select

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">上传</div>
  </div>
)

@Form.create({ name: '' })
class EditGoods extends Component {
  constructor(props) {
    super(props)
    // 3个月区间
    let newDate = new Date()
    newDate.setMonth((newDate.getMonth()) + 3)
    this.state = {
      // 是否派送积分
      reward: true,
      isLoading: true,
      fileList: [],
      videoFile: [],
      goodsCategory: [],
      goodsTopic: [],
      speciData: [{ index: 0 }],
      initTotalCount: 0,
      initSurplusCount: -1,
      editError: null,
      submitting: false,
    }

    this.columns = [
      {
        width: 200,
        title: <div><b style={{ color: '#ff4447' }}>*</b> 规格名称</div>,
        dataIndex: 'specificationsName',
        render: item => <Input placeholder='请输入规格' defaultValue={item} />
      },
      {
        title: <div><b style={{ color: '#ff4447' }}>*</b> 出售价（元）</div>,
        dataIndex: 'salePrice',
        render: item => <InputNumber placeholder='请输入出售价' defaultValue={item ? item / 100 : ''} min={0.01} />
      },
      {
        title: <div><b style={{ color: '#ff4447' }}>*</b> 原价（元）</div>,
        dataIndex: 'originalPrice',
        render: item => <InputNumber placeholder='请输入原价' defaultValue={item ? item / 100 : ''} min={0.01} />
      },
      // {
      //   title: <div><b style={{ color: '#ff4447' }}>*</b> 底价（元）</div>,
      //   dataIndex: 'floorPrice',
      //   render: item => <InputNumber placeholder='请输入底价' defaultValue={item ? item / 100 : ''} min={0.01} />
      // },
      {
        title: <div><b style={{ color: '#ff4447' }}>*</b> 库存数量</div>,
        dataIndex: 'number',
        render: item => <InputNumber placeholder='请输入库存' defaultValue={item} min={0} />
      },
      {
        title: '操作',
        align: 'center',
        render: item => <div style={{ padding: 10 }} ids={item.id} className='delete-box'><Button type="danger" ghost onClick={() => this.speciDelete(item.index)}>删除</Button></div>
      },
    ]
  }

  componentDidMount() {
    const id = this.props.location.search.replace('?id=', '')

    // 商品分类
    const p1 = new Promise((resolve, reject) => {
      goodsCategoryList({ pid: 0 })
        .then(res => {
          const { data } = res
          let list = []
          data.map((value, key) => {
            let tem = {
              value: value.id,
              label: value.name,
              children: []
            }
            if (value.goodsCategories.length > 0) {
              value.goodsCategories.map((v, k) => {
                tem.children.push({
                  value: v.id,
                  label: v.name,
                })
              })
              list.push(tem)
            }
          })
          resolve(list)
        })
    })
    // 商品专题
    const p2 = new Promise((resolve, reject) => {
      goodsTopic().then(res => {
        resolve(res.data)
      })
    })
    // 商品详情
    const p3 = new Promise((resolve, reject) => {
      if (id) {
        getGoodDetail({ id })
          .then(res => {
            resolve(res.data)
          })
      } else {
        resolve(false)
      }
    })

    Promise.all([p1, p2, p3]).then(res => {
      // 商品详情判断
      let info = res[2]
      if (info) {
        info.goodsCategory = [info.goodsCategory.parent.id, info.goodsCategory.id]
      }
      const data = {}
      let initDetail = ''
      if (info) {
        data.fileList = []
        const list = JSON.parse(info.gallery).filter(item => item !== '')
        list.forEach((item, index) => {
          data.fileList.push({ uid: index, name: 'xxx.png', status: 'done', url: item })
        })
        if (info.videoUrl) {
          data.videoFile = [{ uid: 0, name: 'video.mp4', status: 'done', url: info.videoUrl }]
        }
        info.goodSpecifications.forEach(item => {
          this.cont++
          item.index = this.cont
        })
        data.speciData = info.goodSpecifications
        data.info = info
        data.id = info.id
        initDetail = info.detail

        // 记录剩余积分
        if (info.goodsReward) {
          data.initSurplusCount = info.goodsReward.surplusCount
          data.initTotalCount = info.goodsReward.totalCount
          data.browsCount = info.goodsReward.browsCount
          data.browsReward = info.goodsReward.browsReward
          data.watchCount = info.goodsReward.watchCount
          data.watchReward = info.goodsReward.watchReward
        }
      }
      this.initEditor(initDetail)
      this.setState({
        ...data,
        goodsCategory: res[0],
        goodsTopic: res[1],
        isLoading: false,
      })
    })
  }

  // 规格计数
  cont = 0

  // 初始化富文本
  initEditor(detail) {
    this.editor = new Editor('#editor')
    this.editor.customConfig.zIndex = 10
    this.editor.customConfig.menus = [
        'head',  // 标题
        'bold',  // 粗体
        'fontSize',  // 字号
        'fontName',  // 字体
        'italic',  // 斜体
        'underline',  // 下划线
        'strikeThrough',  // 删除线
        'foreColor',  // 文字颜色
        'backColor',  // 背景颜色
        'link',  // 插入链接
        'list',  // 列表
        'justify',  // 对齐方式
        'quote',  // 引用
        'emoticon',  // 表情
        'image',  // 插入图片
        'table',  // 表格
        'video',  // 插入视频
        'code',  // 插入代码
        'undo',  // 撤销
        'redo'  // 重复
    ]
    this.editor.customConfig.customUploadImg = function (files, insert) {

      files.forEach(item => {
        var reader = new FileReader()
        reader.onload = function (e) {
          const context = this
          item.thumbUrl = reader.result
          let img = new Image()
          img.src = item.thumbUrl
          img.onload = function () {
            if (img.height > 3000) {
              message.error('图片高度不能超过3000像素', 3)
              // context.readAsDataURL(null)
            }
            else {
              UploadIMGToOss(item)
                .then(res => {
                  insert(res)
                })
            }

          }

        }
        reader.readAsDataURL(item)
      })
    }
    this.editor.create(detail)
    this.editor.txt.html(detail)
  }
  // 视频上传
  handleVideoPreview = ({ fileList }) => this.setState({ videoFile: fileList })
  // 图片预览 
  handlePreview = (file) => this.PrevImg.show(file.thumbUrl || file.url)
  // 选择图片回调
  handleChange = ({ fileList }) => {
    this.setState({ fileList })
  }
  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.submitting) return
    const _this = this
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { id, reward, fileList, videoFile, initSurplusCount, browsCount, browsReward, watchCount, watchReward } = _this.state
        // 商品参数
        const params = {
          // 基本信息（goodsTopicId、siteType 暂不提交）
          goodsForm: {
            unit: values.unit,
            goodsName: values.goodsName,
            goodsCategoryId: values.goodsCategoryId[1],
            giveReward: values.giveReward,
            maxUseReward: values.maxUseReward,
            detail: _this.editor.txt.html()
          },
        }
        // 奖励信息, 填写了奖励积分总额必须设置观看奖励
        if (reward && (values.totalCount > 0 || values.surplusCount > 0)) {
          // 观看奖励判断
          if (browsCount >= 0 && browsReward >= 0) {
            params.goodsRewardFrom = {
              //是否派送积分
              enable: true,
              // 总奖励
              totalCount: values.totalCount,
              // 剩余积分
              surplusCount: values.surplusCount ? values.surplusCount : values.totalCount,
              // 浏览视频时长/积分奖励
              browsCount,
              browsReward,
            }
            // 之前有设置过派送信息（进来有剩余积分）
            if (initSurplusCount !== -1 && initSurplusCount !== values.surplusCount) {
              params.goodsRewardFrom.totalCount = params.goodsRewardFrom.totalCount + values.surplusCount - initSurplusCount
            }
          } else {
            return message.error('请完善积分奖励设置', 2)
          }
          // 如果有上传视频且填写了奖励总额，必须设置积分奖励
          if (videoFile.length) {
            // 观看时长/奖励
            if (browsCount >= 0 && browsReward >= 0) {
              params.goodsRewardFrom.watchCount = watchCount
              params.goodsRewardFrom.watchReward = watchReward
              params.enable = true
            } else {
              return message.error('请完善积分奖励设置', 2)
            }
          }
        } else {
          params.goodsRewardFrom = {
            totalCount: 0,
            surplusCount: 0,
            browsCount: 0,
            browsReward: 0,
            watchCount: 0,
            watchReward: 0,
            enable: false
          }
        }

        // 规格数据
        const dom = document.querySelector('.space-inner').querySelector('.ant-table-tbody').getElementsByTagName('tr')
        const speci = []
        const getKey = index => ['specificationsName', 'salePrice', 'originalPrice', 'number'][index]
        for (let i = 0; i < dom.length; i++) {
          const tds = dom[i].children
          speci[i] = {}
          for (let j = 0; j < tds.length; j++) {
            if (j < 4) {
              const ipt = tds[j].querySelector('.ant-input') || tds[j].querySelector('.ant-input-number-input') || tds[j].querySelector('.delete-box')
              const keys = getKey(j)
              let value = ipt.value
              if (value) {
                if (j === 3) {
                  value = Number(value)
                } else if (j !== 0) {
                  value = Number(value) * 100
                }
                speci[i][keys] = value
              } else {
                message.error('请完善商品规格数据', 1.5)
                return
              }
            } else if (j === 4) {
              const box = tds[j].querySelector('.delete-box')
              const value = box.getAttribute('ids')
              if (value) {
                speci[i].id = Number(value)
              }
            }
          }
        }
        params.goodsSpecificationFroms = speci
        _this.setState({ submitting: true })
        const hide = message.loading('数据提交中...')
        const finishSubmit = () => {
          hide()
          _this.setState({ submitting: false })
        }
        // 视频判断
        const videoPrms = new Promise((resolve, reject) => {
          // 有视频
          if (videoFile.length) {
            // 有url地址是编辑，有数据的
            if (videoFile[0].url) {
              params.goodsForm.videoUrl = videoFile[0].url
              resolve()
              // 新上传的
            } else {
              UploadIMGToOss(videoFile[0])
                .then(data => {
                  params.goodsForm.videoUrl = data
                  resolve()
                })
                .catch(function (err) {
                  finishSubmit()
                  reject(err)
                  message.error('视频上传失败！', 1.5)
                  return false
                })
            }
            // 没有视频
          } else {
            resolve()
          }
        })
        // 图片上传
        videoPrms.then(() => {
          const prmsArr = []
          const imgArr = fileList.slice(0, 5)
          imgArr.forEach((item, index) => {
            prmsArr[index] = new Promise((resolve, reject) => {
              if (item.url) {
                resolve(item.url)
              } else {
                UploadIMGToOss(item)
                  .then(data => {
                    resolve(data)
                  })
                  .catch(function (err) {
                    finishSubmit()
                    message.error('图片上传失败！', 1.5)
                    reject(err)
                    return false
                  })
              }
            })
          }) 
             Promise.all(prmsArr)
            .then(gallery => {
              params.goodsForm.gallery = gallery
              params.goodsForm.picUrl = gallery[0]
              editGoods(params, id)
                .then(res => {
                  finishSubmit()
                  message.success('编辑成功!', 1.2, () => {
                    _this.props.history.replace('/goods/detail?id=' + res.data.id)
                  })
                })
                .catch(() => {
                  finishSubmit()
                })
            })
            .catch(() => {
              finishSubmit()
            })
        })
      } else {
        document.querySelector('#main').scrollTop = 0
      }
    })
  }
  // 删除规格
  speciDelete = (index) => {
    let { speciData, id } = this.state
    const curObj = speciData.filter(item => item.index === index)[0]
    speciData = speciData.filter(item => item.index !== index)
    const _this = this
    if (curObj.id) {
      Modal.confirm({
        title: '提示！',
        content: '确定要删除这个已生成的商品规格吗？',
        onOk() {
          goodsSpeciDelete({
            id: curObj.id,
            goodsId: id,
          })
            .then(res => {
              _this.setState({ speciData })
              message.success('删除成功!', 2)
            })
        },
        onCancel() {
          // 取消操作
        },
      })
    } else {
      this.setState({ speciData })
    }
  }

  // 添加规格
  addSpeci = () => {
    let { speciData } = this.state
    this.cont++
    speciData.push({ index: this.cont })
    this.setState({ speciData })
  }

  render() {
    const {
      id,
      info,
      isLoading,
      fileList,
      speciData,
      videoFile,
      goodsCategory,
      reward,
    } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Layout className="edit-goods-page" style={{ padding: 20, paddingTop: 40, backgroundColor: 'white' }}>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title={id ? '编辑商品' : '新增商品'} style={{ borderLeft: '5px solid #1890ff', height: 30 }} />
        <div className="page-content" style={{ paddingTop: 20 }}>
          <Form onSubmit={this.handleSubmit} style={{ paddingLeft: 100, paddingRight: 100 }}>
            <PageHeader title='商品类别' style={{ paddingLeft: 0 }} />
            <Form.Item label="商品分类：" className='flex'>
              {getFieldDecorator('goodsCategoryId', {
                rules: [{
                  required: true,
                  message: '请选择商品分类',
                }],
                initialValue: info ? info.goodsCategory : '',
              })(
                // <Select
                //   style={{width: 600}}
                //   onChange={this.handleSelectChange}
                // >
                //   {goodsCategory.map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                // </Select>
                <Cascader
                  style={{ width: 600 }}
                  options={goodsCategory}
                  expandTrigger="hover"
                  // displayRender={this.displayRender}
                  onChange={this.handleSelectChange}
                  placeholder='请选择分类'
                />
              )}
            </Form.Item>
            {/* 商品专题、所属站点：暂时隐藏，后续可能重新启用
            <Form.Item label="商品专题：" className='flex'>
              {getFieldDecorator('goodsTopicId', {
                rules: [{
                  required: true,
                  message: '请选择商品专题',
                }],
                initialValue: info ? info.goodsTopic.id : '',
              })(
                <Select
                  style={{ width: 600 }}
                  onChange={this.handleSelectChange}
                >
                  {goodsTopic.map(item => <Option value={item.id} key={item.id}>{item.name}</Option>)}
                </Select>
              )}
            </Form.Item>
            <Form.Item label="所属站点：" className='flex'>
              {getFieldDecorator('siteType', {
                rules: [{
                  required: true,
                  message: '请选择所属站点',
                }],
                initialValue: info ? info.siteType : '',
              })(
                <Select
                  style={{ width: 600 }}
                  onChange={this.handleSelectChange}
                >
                  <Option value={1} key={1}>惠城本土</Option>
                  <Option value={2} key={2}>博罗本土</Option>
                  <Option value={3} key={3}>惠东本土</Option>
                  <Option value={4} key={4}>龙门本土</Option>
                  <Option value={0} key={0}>其它</Option>
                </Select>
              )}
            </Form.Item>
            */}
            <PageHeader title='商品信息' style={{ paddingLeft: 0, marginBottom: 20 }} />
            <Form.Item label="商品名称：" className='flex'>
              {getFieldDecorator('goodsName', {
                rules: [{
                  required: true,
                  min: 2,
                  max: 255,
                  message: '输入6~30字数的商品名称',
                }],
                initialValue: info ? info.goodsName : '',
              })(
                <Input placeholder="输入商品名称，6-255个字符" style={{ width: 600, height: 40 }} />
              )}
            </Form.Item>
            <Form.Item label="商品单位：" className='flex'>
              {getFieldDecorator('unit', {
                rules: [{
                  required: true,
                  message: '请输入商品单位',
                }],
                initialValue: info ? info.unit : '',
              })(
                <Input placeholder="输入商品单位（如：件、个、台）" style={{ width: 600, height: 40 }} />
              )}
            </Form.Item>
            <Form.Item label={<span><b style={{ color: '#f5222d' }}>*</b> 规格参数</span>} className='flex'>
              <Table
                className='space-inner'
                style={{ width: 800 }}
                bordered
                rowKey='index'
                columns={this.columns}
                dataSource={speciData}
                pagination={false}
              />
              {speciData.length < 6 ? <div className="flex-a-a" style={{ padding: 20 }}><Button style={{ width: 250, height: 40 }} onClick={this.addSpeci} icon='plus'>添加规格</Button></div> : ''}
            </Form.Item>
            <Form.Item label="商品短视频：" className='flex'>
              {getFieldDecorator('video', {
                initialValue: info ? info.gallery : '',
              })(
                <Upload
                  className='upload-img'
                  action=''
                  multiple
                  name='file'
                  fileList={videoFile}
                  listType="picture"
                  onChange={this.handleVideoPreview}
                  beforeUpload={() => { return false }}
                >
                  {videoFile && videoFile.length >= 1 ? null : <Button><Icon type="upload" /> 上传视频</Button>}
                </Upload>
              )}
              <p className='desc-text' style={{ paddingTop: 10 }}>短视频内容最低10秒，不可超过1分钟</p>
            </Form.Item>
            <Form.Item label="商品图片：" className='flex'>
              {getFieldDecorator('gallery', {
                rules: [{
                  required: true,
                  message: '请上传商品图片',
                }],
                initialValue: info ? info.gallery : '',
              })(
                <Upload
                  className='upload-img flex'
                  action=""
                  multiple
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={this.handlePreview}
                  onChange={this.handleChange}
                  beforeUpload={() => { return false }}
                >
                  {fileList && fileList.length >= 5 ? null : uploadButton}
                </Upload>
              )}
              <p className='desc-text'>上传图片的最佳尺寸：720像素*720像素，其他尺寸会影响页效果，格式png，jpeg，jpg，gif。<br />大小不超过2M，商品图片一共可以上传5张，默认第一张为封面主图</p>
            </Form.Item>
            <Form.Item label="商品描述：" className='flex'>
              <div id="editor" className='editor-inner' />
            </Form.Item>
            <PageHeader title='奖励积分规则' style={{ paddingLeft: 0, marginBottom: 20 }} />
            {/* 派送积分规则:
                1、默认选择状态为配送积分，但积分不是必须送，可不填写。
                2、一旦设置了派送总积分则必须设置浏览商品的奖励设置，上传了视频才会显示观看视频奖励设置。
                3、初次设置派送总积分只需要设置总积分数，编辑商品时若之前有设置派送积分则显示剩余积分数，可修改且只能修改剩余积分数。
                4、提交编辑时需要提交剩余积分，初次添加商品剩余积分数等于总派送积分数。
            */}
            <Form.Item label="是否派送积分：" className='flex'>
              {getFieldDecorator('reward', {
                initialValue: !!reward,
                valuePropName: 'checked'
              })(
                <Switch checkedChildren="是" unCheckedChildren="否" onChange={(reward) => this.setState({ reward })} />
              )}
            </Form.Item>
            {
              (!isLoading && reward) && (
                <div>
                  {
                    info && info.goodsReward && info.goodsReward.surplusCount >= 0
                      ? (
                        <div>
                          <Form.Item label="预派送总积分：" className='flex'>
                            {getFieldDecorator('totalCount', {
                              initialValue: info && info.goodsReward && info.goodsReward.totalCount >= 0 ? info.goodsReward.totalCount : '',
                            })(
                              <InputNumber disabled placeholder="输入派送总额" style={{ width: 220, height: 40 }} />
                            )}
                          </Form.Item>
                          <Form.Item label="派送剩余总积分：" className='flex'>
                            {getFieldDecorator('surplusCount', {
                              initialValue: info && info.goodsReward && info.goodsReward.surplusCount >= 0 ? info.goodsReward.surplusCount : '',
                            })(
                              <InputNumber placeholder="剩余派送总积分" style={{ width: 220, height: 40 }} />
                            )}
                          </Form.Item>
                        </div>
                      )
                      : (
                        <Form.Item label="派送总积分：" className='flex'>
                          {getFieldDecorator('totalCount', {
                            initialValue: info && info.goodsReward && info.goodsReward.totalCount >= 0 ? info.goodsReward.totalCount : '',
                          })(
                            <InputNumber placeholder="输入派送总额" style={{ width: 220, height: 40 }} min={1} />
                          )}
                        </Form.Item>
                      )
                  }
                  <Form.Item label="浏览商品时长：" className='flex'>
                    <InputNumber placeholder="浏览商品时长数，最低10秒" defaultValue={info && info.goodsReward && info.goodsReward.browsCount >= 0 ? info.goodsReward.browsCount : ''} style={{ width: 220, height: 40 }} onChange={value => this.setState({ browsCount: value })} />
                    <span style={{ margin: 10 }}>秒，可获得积分</span>
                    <InputNumber placeholder="每次浏览商品可获得积分数量" defaultValue={info && info.goodsReward && info.goodsReward.browsReward >= 0 ? info.goodsReward.browsReward : ''} style={{ width: 220, height: 40 }} onChange={value => this.setState({ browsReward: value })} />
                  </Form.Item>

                  {
                    !!videoFile.length && (
                      <Form.Item label="观看视频时长：" className='flex'>
                        <InputNumber placeholder="浏览视频时长数，最低10秒" defaultValue={info && info.goodsReward && info.goodsReward.watchCount >= 0 ? info.goodsReward.watchCount : ''} style={{ width: 220, height: 40 }} onChange={value => this.setState({ watchCount: value })} />
                        <span style={{ margin: 10 }}>秒，可获得积分</span>
                        <InputNumber placeholder="每次浏览视频可获得积分数量" defaultValue={info && info.goodsReward && info.goodsReward.watchReward >= 0 ? info.goodsReward.watchReward : ''} style={{ width: 220, height: 40 }} onChange={value => this.setState({ watchReward: value })} />
                      </Form.Item>
                    )
                  }
                  <Form.Item label="购买赠送积分" className='flex'>
                    {getFieldDecorator('giveReward', {
                      initialValue: info && info.giveReward,
                    })(
                      <InputNumber placeholder="输入购买赠送积分" style={{ width: 220, height: 40 }} />
                    )}
                  </Form.Item>
                  <Form.Item label="最大可抵扣积分" className='flex'>
                    {getFieldDecorator('maxUseReward', {
                      initialValue: info && info.maxUseReward,
                    })(
                      <InputNumber placeholder="输入最大可抵扣积分" style={{ width: 220, height: 40 }} />
                    )}
                  </Form.Item>
                </div>
              )
            }
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={this.state.submitting} disabled={this.state.submitting} size='large' style={{ width: 220, marginLeft: 120, marginTop: 40 }}>保存</Button>
            </Form.Item>
          </Form>
        </div>
      </Layout>
    )
  }
}

export default EditGoods